export default {
  title: "用专业服务用户",
  useNow: "立即使用",
  faq1q: "问：什么是激活码？",
  faq1a: "激活码是发放可兑换软件服务产品的一串随机字母凭证，兑换成功后店铺将获得对应生效周期的服务。",
  faq2q: "问：如何获得激活码？",
  faq2a: "购买后联系客服获得激活码。",
  faq3q: "问：如何使用激活码？",
  faq3a: "获得激活码以后，可在激活码兑换页，输入激活码，进行兑换。每个激活码仅可兑换一次，兑换成功后，即可获得相应的使用期限。",
  faq4q: "问：激活码有效期是多久？",
  faq4a: "激活码的兑换有效期为365日，自激活生成之时起开始计算。",
  answerPrefix: "答：",
};
